import type {IMaterialData, MeshRenderSettings} from "@cm/material-nodes"
import {keyForMaterialData} from "@cm/material-nodes"
import {hashObject} from "@cm/utils"

export function keyForMeshMaterialData(materialData: IMaterialData, meshRenderSettings: MeshRenderSettings | undefined) {
    if (meshRenderSettings === undefined) {
        return keyForMaterialData(materialData)
    }

    const {
        displacementImage,
        displacementUvChannel,
        displacementMin,
        displacementMax,
        displacementNormalStrength,
        displacementNormalSmoothness,
        displacementNormalOriginalResolution,
    } = meshRenderSettings

    if (displacementImage === undefined) {
        return keyForMaterialData(materialData)
    }

    return hashObject({
        materialMaterialData: keyForMaterialData(materialData),
        displacementImageNodeHash: displacementImage.imageNode.hash,
        displacementUvChannel,
        displacementMin,
        displacementMax,
        displacementNormalStrength,
        displacementNormalSmoothness,
        displacementNormalOriginalResolution,
    })
}
